module.exports = __webpack_public_path__ + "static/accurkardia_cover-82b244c19d905057665e5199003a3a93.png";